import { useState, useEffect } from 'react'
import { impersonate } from 'auth'

const useImpersonate = (props) => {
  const [status, setStatus] = useState('')
  const [title, setTitle] = useState('Please wait...')
  const [subTitle, setSubTitle] = useState('')

  useEffect(() => {
    const queryString = props.location.search
    const urlParams = new URLSearchParams(queryString)
    const jwt = urlParams.get('jwt')
    const key = urlParams.get('key')

    if (!jwt) {
      window.location = '/'
    } else {
      impersonate(jwt, urlParams.get('admin') === 'true', key)
        .then((redirectURL) => {
          setStatus('success')
          setTitle(`Welcome back!`)
          setSubTitle('Please wait, we will redirect you to your dashboard')
          window.location = redirectURL
        })
        .catch((error) => {
          setTitle('Login failed')
          setSubTitle(`Error from server: ${error} <br />Please try again`)
          setStatus('error')
        })
    }
  }, [])

  return {
    status,
    title,
    subTitle,
  }
}

export default useImpersonate
